<template>
      <v-layout wrap
        v-if="question.title && ((answers && answers.length>0 && !add) || (add && !answered)) || Role('lead')"
        class="mb-5 pl-5">
          
          <v-flex xs11>
            <v-layout wrap>
                <v-flex xs12>
                  <v-icon v-role:hide.supplier v-if="hover" class="handle" style="font-size:22px;position:absolute;margin-left:-30px">unfold_more</v-icon>
                 <v-text-field v-model="main_answer.answer"
                      solo flat  hide-details
                      class="pa-0 ma-0 border-less"
                      style="font-size:16px!important;font-weight:bold"
                      @focussss="select"
                      @change="save"
                      :readonly="Role('supplier')"
                    ></v-text-field>
                </v-flex>
                 <v-flex xs12 v-if="!answered && question.description">{{question.description}}</v-flex>
                <v-flex xs12 v-if="Role('supplier') && otherAnswers.length > 0 && show_info">
                  <v-list dense class="pa-0">
                 <template v-for="answer in otherAnswers">
                   <v-hover v-slot:default="{ hover }" v-if="answer.text && answer.text!=''" >
                       <v-list-item  v-if="answer.owner.role=='supplier'" style="margin-left: -50px;padding-left: 0;">
                          <v-list-item-avatar style="margin-right:10px;">
                             <img v-if="answer.owner.avatar" v-avatar:logo :src="answer.owner.avatar">
                              <span v-else class="white--text headline">{{answer.owner.name.initials()}}</span>
                          </v-list-item-avatar>
                
                          <v-list-item-content>
                            <v-list-item-title>{{answer.owner.organisation}} - {{answer.owner.name}}</v-list-item-title>
                            <v-list-item-subtitle><b v-if="(question.type =='check' || answer.owner.role=='supplier') && answer.options && answer.options.length > 0">{{answer.options.join(', ')}}<template v-if="answer.text">:&nbsp;</template></b>{{answer.text}}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn icon>
                              <v-icon class="reomove-button" v-if="hover && Role('admin')" @click="deleteAnswer(answer)">delete</v-icon>
                            </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                         <v-list-item v-else class="pa-0">
                           <b v-if="(question.type =='check' || answer.owner.role=='supplier') && answer.options && answer.options.length > 0">{{answer.options.join(', ')}}<template v-if="answer.text">:&nbsp;</template></b>{{answer.text}}
                            <v-list-item-action>
                            <v-btn icon>
                              <v-icon class="reomove-button" v-if="hover && Role('admin')" @click="deleteAnswer(answer)">delete</v-icon>
                            </v-btn>
                            </v-list-item-action>
                         </v-list-item>
                   </v-hover>
                   </template>
                   </v-list>
                </v-flex>
                   <v-flex xs12 v-if="Role('supplier')"><i>Ondersteunt uw pakket dit?</i></v-flex>
                  <v-flex>
                  <v-btn-toggle v-if="Role('supplier')"
                  style="position:absolute;right:50px;margin-top:-10px"
                    v-model="answer.score"
                    class="v-item-rating transparent"
                    active-class="v-item--active-rating">
                    <v-btn text v-for="score in scores" class="v-item-rating" :key="score.value" :value="score.value" @click="answerThis(score.value, score.text2)">
                      {{ score.text2 }}
                    </v-btn>
                  </v-btn-toggle></v-flex>
                  <v-flex xs12 v-if="answeredByMe || (Role('admin,reseller') && isMine(answer,true))">
                   <q-combobox ref="combobox" v-if="question.type=='check'" @update="update" :question="question" :answer="answer" :current="current"></q-combobox>
                    <v-textarea ref="textfield"
                     :prefix="scoreText"
                                    v-model="answer.text"
                                  auto-grow
                                  hide-details
                                  :autofocus="current"
                                  placeholder="..."
                                  @focus="select"
                                  @blur="update"
                                  :class="{'pa-0 ma-0 border-less': true, 'empty': !current && (!answer.text || answer.text.length == 0)}"
                                  :rows="1"
                                  style="font-size:inherit!important;min-height:auto"
                                ></v-textarea>
                 </v-flex>
                 <v-expand-transition>
                 <v-flex xs12 v-show="show" v-if="!Role('supplier') && otherAnswers.length > 0 && show_info">
                                    <template v-for="answer in otherAnswers">
                   <v-hover v-slot:default="{ hover }" >
                       <v-list-item  v-if="answer.owner.role=='supplier'" style="margin-left: -50px;padding-left: 0;">
                          <v-list-item-avatar style="margin-right:10px;">
                             <img v-if="answer.owner.avatar" v-avatar:logo :src="answer.owner.avatar">
                              <span v-else class="white--text headline">{{answer.owner.name.initials()}}</span>
                          </v-list-item-avatar>
                
                          <v-list-item-content>
                            <v-list-item-title>{{answer.owner.organisation}} - {{answer.owner.name}}</v-list-item-title>
                            <v-list-item-subtitle><b v-if="(question.type =='check' || answer.owner.role=='supplier') && answer.options && answer.options.length > 0">{{answer.options.join(', ')}}<template v-if="answer.text">:&nbsp;</template></b>{{answer.text}}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn icon>
                              <v-icon class="reomove-button" v-if="hover && Role('admin')" @click="deleteAnswer(answer)">delete</v-icon>
                            </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                         <v-list-item v-else class="pa-0">
                           <b v-if="(question.type =='check' || answer.owner.role=='supplier') && answer.options && answer.options.length > 0">{{answer.options.join(', ')}}<template v-if="answer.text">:&nbsp;</template></b>{{answer.text}}
                            <v-list-item-action>
                            <v-btn icon>
                              <v-icon class="reomove-button" v-if="hover && Role('admin')" @click="deleteAnswer(answer)">delete</v-icon>
                            </v-btn>
                            </v-list-item-action>
                         </v-list-item>
                   </v-hover>
                   </template>
                 </v-flex>
                 </v-expand-transition>
              </v-layout>
            </v-flex>
              <v-flex xs1>
                 <v-btn
                    icon
                    @click="show = !show"
                    style="position:absolute;margin-right:-100px"
                     v-show="hover || current" 
                     v-if="!Role('supplier') && otherAnswers.length > 0 && show_info"
                  >
                    <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  </v-btn>
               <v-menu v-if="Role('admin,reseller,lead')">
                <template v-slot:activator="{ on }">
                  <v-btn v-show="hover || current" 
                    icon
                    v-on="on"
                    style="float:right"
                    tabindex="-1"
                  >
                    
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
    
                <v-list>
                  <v-list-item-group 
                  active-class="v-item--active-rating"
                  class="v-item-rating"
                  v-model="answer.score" v-role:hide.supplier>
                     <v-list-item
                        v-for="score in scores"
                        :key="score.value"
                        :value="score.value"
                        @click="answerThis(score.value, score.text)"
                      >
                        <v-list-item-icon><v-icon color="grey lighten-1" v-text="score.icon"></v-icon></v-list-item-icon>
                          <v-list-item-title v-text="score.text"></v-list-item-title>
                        
                      </v-list-item>
                   </v-list-item-group>
                  <v-list-item v-if="question.type=='radio' && answer.options && answer.options[0] == 'NEE'"
                    @click="changeOption('JA','answer')"
                  >
                    <v-list-item-icon><v-icon color="grey lighten-1">check</v-icon></v-list-item-icon>
                    <v-list-item-title>Ja</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="question.type=='radio' && answer.options && answer.options[0] == 'JA'"
                    @click="changeOption('NEE','no_answer')"
                  >
                    <v-list-item-icon><v-icon color="grey lighten-1">close</v-icon></v-list-item-icon>
                    <v-list-item-title>Nee</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="question.type=='checkss'"
                    @click="question.edit=true"
                  >
                    <v-list-item-icon><v-icon color="grey lighten-1">edit</v-icon></v-list-item-icon>
                    <v-list-item-title>Lijst aanpassen</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="deleteAnswer"
                  >
                    <v-list-item-icon><v-icon color="grey lighten-1">delete</v-icon></v-list-item-icon>
                    <v-list-item-title>Verwijderen</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              
              
            </v-flex>
      </v-layout>
</template>
<script>
import {
  mapGetters, mapMutations, mapState
} from 'vuex'
export default {
  props: {
      add : {
          type: Boolean,
          default: false
      },
      question: {
        type: Object,
        default: () => {}
      },
      main_answer: {
        type: Object,
        default: () => {}
      },
      answers: {
        type: Array,
        default: () => []
      },
      changed : {
          type: Boolean,
          default: false
      },
      hover: {
          type: Boolean,
          default: false
      },
      show_info: {
          type: Boolean,
          default: false
      },
      impersonate : {
        type: String,
        default: null
      },
    },
   data: () => ({
     scores: [{value: 5, text: 'Eis', text2: 'Ja', icon: 'check_circle_outline'},
              {value: 3, text: 'Wens', text2: 'Deels', icon: 'error_outline'},
              {value: 0, text: 'NVT', text2: 'Nee', icon: 'block'}],
      score: -1,
      edit: false,
      show: true
  }),

  watch: {
    changed (value,old){
        this.changed = true
    },
    answer (value,old) {
      if (value.toString()!=old.toString() ) this.changed = true
      if (!this.answer.answer) this.answer.answer = this.question.title
    },
    score (value,old){
      /*TODO*/
      /*this.question.score = value
      let score = this.scores.filter(s => s.value == value)[0]
      this.question.checks= [score.text2]
      if (!this.answeredByMe) {
        console.log('answerthis report')
        this.answerThis()
      }*/ 
    }
  },
  mounted() {
    this.score = this.answer.score > -1 ? this.answer.score : -1
    if (this.answer && !this.answer.answer) this.answer.answer = this.answer.question
    //if (this.answer && this.answer.score > -1) this.score = this.answer.score
  },
  computed: {
    ...mapGetters('auth', ["Role",'relation',"maincontact"]),
      ...mapGetters('match', ['currentQuestion']),
        ...mapState('auth', ['authenticated',"settings"]),
    answered() {
        return this.answers.length > 0 ? true: false
    },
    answer() {
      return this.answers.filter(q => q.owner.name == this.maincontact.name)[0] || {}
    },
    answeredByMe() {
        return this.answers.filter(q => this.isMine(q) == true).length > 0  
    },
    otherAnswers(){
      if (this.Role('supplier')) return this.answers.filter(q => q.owner && q.owner.role!='supplier' && q.owner.name != this.maincontact.name)
      return this.answers.filter(q => q.owner && q.owner.name != this.maincontact.name)
    },
    current(){
        return this.currentQuestion.title ==   this.answer.question
    },
    text () {
      return this.question.text
    },
    scoreText (){
      if (this.Role('lead') && this.answer.options[0]) return this.answer.options[0] + ': '
      return ''
    },
    title: {
            get() {
                 return this.answer.answer
            },
            set(value) {
                this.answer.answer = value
            }
      },
    options () {
        if ((this.question.type == 'check' || this.answer.answer == this.question.title) && this.answer.options && this.answer.options.length>0) return this.answer.options.join(', ')
        return false
    }
  },
  methods: {
      ...mapMutations('match', ["setQuestion","deleteQuestion"]),
    answerThis (score, option) {
        if (this.answer && this.answer.question) {
          if (score) this.answer.score = score
          if (!this.answer.options) this.answer.options = []
          //if (option && this.answer.options.indexOf(option)==-1) this.answer.options.push(option)
          if (option) this.answer.options =[option]
          this.update()
        } else{
          if (score) this.question.score = score
          if (option) this.question.checks.push(option)
          this.$emit('answer', this.question)
        }
    },
    deleteAnswer(answer){
        if (!answer) answer = this.answer
         if (this.Role('lead')) this.deleteQuestion({title: this.answer.question})
         this.$emit('deleteAnswer', this.answer)
         
    },
    update() {
        /*var t = this.question.text
        if (t == '') return false
        this.question.text = ''*/
        this.$emit('update', this.answer.text, this.answer )
        
    },
    changeOption(option, answer){
      this.answer.options=[option]  
      if (this.question[answer]) {
        this.answer.answer = this.question[answer]
        this.$emit('update', this.answer.text, this.answer )
      } else if (this.answer.text && this.answer.text.length > 0) { //KEEP
        this.answer.answer = this.question.title
      
      } else if (this.answers.length > 1){ //more answers = > optional
        this.question.optional = true
         this.deleteAnswer()
      } else { //only current answer delete question
        this.deleteQuestion(this.question)
      }
      
    },
     isMine(answer,includeAdmin){
      if (!answer.owner) return true
      if (includeAdmin && this.Role("_admin,_reseller") && (answer.owner.role == 'admin' || answer.owner.role == 'reseller')) return true
      if (answer.owner.name == this.maincontact.name) return true
      return false
    },
    select(){
      this.setQuestion(this.question)
      this.edit = false
      if (this.$refs.combobox && this.question.type=='check') {
        this.$refs.combobox.activateMenu()
      }else if (this.$refs.textfield) {
        this.$refs.textfield.focus()
      }
    },
     save(){
      this.modified = true
      this.edit = false
      this.changed = false
    },
     questionMark(question) {
              if (question.title && question.title.indexOf('?') == -1) return '?'
          },
  }
}
String.prototype.replaceAll = function(target, replacement) {
  return this.split(target).join(replacement);
};
String.prototype.initials = function(name) {
  if (!name) return false
var initials = name.match(/\b\w/g) || [];
return  ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
}
</script>
<style>
  .border-less textarea,
  .border-less input{
    padding: 0px!important;
    margin:0px;
    
  }
  .text-capitalize textarea{
    text-transform: uppercase;
  }  
    .v-text-field.border-less > .v-input__control > .v-input__slot:before, 
  .v-text-field.border-less > .v-input__control > .v-input__slot:after {
    display:none;
  }
  
  .v-text-field.border-less .v-input__control {
    min-height: auto;
  }
  .v-text-field.border-less .v-text-field__details, 
  .v-text-field.border-less > .v-input__control > .v-input__slot {
     padding: 0;
  }
.v-textarea.empty textarea {
  height: auto!important;
  min-height:auto!important;
}
.v-autocomplete__content {
  -webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
}
.v-item--active-rating:before {
  display:none;
}
.v-application .grey--text {
    color: #9e9e9e !important;
    caret-color: #9e9e9e !important;
}
.theme--light.v-item-rating{
  
  color: grey;
}
.v-item--active-rating {
  font-weight: bold;
  background: transparent!important;
  color: black!important;
}
.reomove-button {
   float:right;
}
.v-textarea .v-text-field__prefix {
   padding-top: 0px;
    margin-top: 0px;
    line-height: 1.3;
}
</style>